import { useRef } from "react";
import { useInView } from "framer-motion";

const WORDS = ["iPhone", "MacBook", "iPad", "Apple Watch", "HPrime", "Novo • Lacrado (Americano) com 1 ano de garantia Apple", "Seminovos com 4 meses de garantia", "Encomendas em até 7 dias ou seu dinheiro de volta", "Até 21x", "Direto no WhatsApp"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display px-6 sm:px-10 text-5xl sm:text-7xl lg:text-8xl font-extrabold tracking-[-0.04em] ${i % 2 ? "text-outline" : "text-white"}`}>{w}</span>
        <img src="/brand/mark-white.png" alt="" className="h-7 sm:h-10 w-auto opacity-70" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { margin: "100px 0px" });
  return (
    <section ref={ref} data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 py-8 sm:py-12 bg-[#0c0c0e]">
      <div className={`marquee-track flex w-max ${inView ? "" : "is-paused"}`}>
        <Row />
        <Row hidden />
      </div>
    </section>
  );
};
